export default __webpack_public_path__ + "static/media/header.d58501cb.png";